import { Company, FrenchCompany } from '../types'

export const getCompanyName = (company?: Partial<Company> | Partial<FrenchCompany> | null): string | undefined => {
  if (!company) {
    return undefined
  }

  return company.name || company.legalName || undefined
}
